var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":_vm.id,"src":_vm.printPath}})
}
var staticRenderFns = []

export { render, staticRenderFns }